import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const CardBalanceDepositar = ({ balance = "$ 3,000,000.32", balanceOff = true, label, icon, hover = true, textLabel, textBalance, onClick, className }) => {
  const [statusHover, setStatusHover] = useState(false);

  return (
    <div
      className={`w-full h-[165px] flex flex-col py-6 px-6 bg-[#5E5E6329] mb-4 rounded-xl gap-4 border border-[transparent] hover:border-[#ffffff68] transition cursor-pointer justify-end ${className}`}
      onMouseEnter={() => setStatusHover(true)}
      onMouseLeave={() => setStatusHover(false)}
      onClick={onClick}
    >
      <div className="flex flex-row">
        {icon && <img src={icon} className="h-6" alt="" />}
      </div>
      <div className="w-full h-auto flex flex-col justify-center items-start gap-1">
        <p className={`text-[14px] text-white font-normal traking-[-0.14px] leading-5 text-start ${textLabel}`}>
          {label}
        </p>
        <AnimatePresence>
          {(hover ? statusHover : true) && (
            <motion.div
              className="w-full"
              initial={{ height: 0, opacity: 0 }}
              animate={{ height: 'auto', opacity: 1 }}
              exit={{ height: 0, opacity: 0 }}
              transition={{ duration: 0.3, ease: 'easeInOut' }}
              style={{ overflow: 'hidden' }}
            >
              <motion.p
                className={`text-[#8A8A8E] font-normal traking-[-0.16px] leading-5 text-left ${textBalance}`}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.3, ease: 'easeInOut' }}
              >
                {balanceOff && (balance === "0.00" ? '$ 0,00' : balance)}
              </motion.p>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
};

export default CardBalanceDepositar;
